import axios from 'axios';

import { LogService } from '../log-service';

export const getSellerTaxIdentifiers = async ({ includeInactive = false }) => {
  try {
    const response = await axios.get(`/taxIdentifiers?includeInactive=${includeInactive}`);
    const result = response?.data ?? [];
    return result.reduce((acc, d) => {
      return { ...acc, [d.taxIdentifierId]: d };
    }, {});
  } catch (error) {
    LogService.logError(new Error('Error fetching seller tax identifiers', { cause: error }));
  }
};

export const addSellerTaxIdentifier = async (data) => {
  const response = await axios.post('/taxIdentifiers', data);
  const result = response?.data ?? [];
  return result;
};

export const getTaxData = async () => {
  const response = await axios.get('/seller/taxData');
  return response?.data;
};

export const createTaxData = async (payload) => {
  const response = await axios.post('/seller/taxData', payload);
  return response?.data;
};

export const updateTaxData = async (payload) => {
  const response = await axios.put('/seller/taxData', payload);
  return response?.data;
};

export const deleteSellerTaxIdentifier = async (taxIdentifierId) => {
  const response = await axios.put(`/taxIdentifiers/deactivate/${taxIdentifierId}`);
  const result = response?.data ?? [];
  return result;
};

export const getFulfillmentPlanTaxIdentifiers = async (fulfillmentPlanId) => {
  const response = await axios.get(`/taxIdentifiers/fulfillmentPlan/${fulfillmentPlanId}`);
  const result = response?.data ?? [];
  return result;
};

export const postFulfillmentPlanTaxIdentifiers = async (fulfillmentPlanId, data) => {
  const reqBody = { taxIdentifierIds: data };
  const response = await axios.post(`/taxIdentifiers/fulfillmentPlan/${fulfillmentPlanId}`, reqBody);
  const result = response?.data ?? [];
  return result;
};
